import { gql, useLazyQuery } from '@apollo/client';
import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { Query, StopAssistantResponseInput } from 'generated/graphql';
import { useCallback } from 'react';
import { useGetUser } from 'v2/core/services/user';

const STOP_ASSISTANT_RESPONSE_QUERY = gql`
  query stopAssistantResponse($tenantID: ID!, $userID: ID!, $responseID: ID!) {
    stopAssistantResponse(
      request: { tenantID: $tenantID, userID: $userID, responseID: $responseID }
    )
  }
`;

export function useStopAssistantResponse() {
  const {
    id: userID,
    tenant: { id: tenantID },
  } = useGetUser();

  const { showErrorNotification } = useNotificationContext();

  const [stopAssistantResponse, resp] = useLazyQuery<
    Query,
    StopAssistantResponseInput
  >(STOP_ASSISTANT_RESPONSE_QUERY, {
    fetchPolicy: 'network-only',
    onError: () => {
      showErrorNotification({
        contentComponent: 'Failed to stop Wisdom response.',
        props: {},
      });
    },
  });

  const stopAssistantResponseWrapper = useCallback(
    async (promptID: string) => {
      return stopAssistantResponse({
        variables: {
          tenantID,
          userID,
          responseID: promptID,
        },
      });
    },
    [userID, tenantID, stopAssistantResponse],
  );

  return [
    stopAssistantResponseWrapper,
    {
      isSuccessful: resp.data?.stopAssistantResponse ?? false,
      isLoading: resp.loading,
    },
  ] as const;
}
